/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Resume_Hint_RunningInputs */

const en_directory_submit_enrich_resume_hint_running = /** @type {(inputs: Directory_Submit_Enrich_Resume_Hint_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Re-running the failed step — completed steps are reused from cache, no refetch and no extra cost.`)
};

const zh_directory_submit_enrich_resume_hint_running = /** @type {(inputs: Directory_Submit_Enrich_Resume_Hint_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在重跑失败模块 — 已完成的步骤直接复用缓存，不重新抓取、不重复计费。`)
};

/**
* | output |
* | --- |
* | "Re-running the failed step — completed steps are reused from cache, no refetch and no extra cost." |
*
* @param {Directory_Submit_Enrich_Resume_Hint_RunningInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_resume_hint_running = /** @type {((inputs?: Directory_Submit_Enrich_Resume_Hint_RunningInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Resume_Hint_RunningInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_resume_hint_running(inputs)
	return zh_directory_submit_enrich_resume_hint_running(inputs)
});
export { directory_submit_enrich_resume_hint_running as "directory.submit.enrich.resume_hint_running" }